/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const GlobalScannerPage = lazyLoad(
  () => import('./index'),
  module => module.GlobalScannerPage,
);
